import { CHILD_MAX_AGE } from "Components/Features/CheckPrice/Products/LifeProducts/Child/childConstants";
import { isChild, isInfant } from "Utils/ageUtils";

export const getChildAgeDatesOfBirth = (datesOfBirth: string[]): Date[] =>
  datesOfBirth
    .map((dob) => new Date(dob))
    .filter((dob) => isChild(dob, CHILD_MAX_AGE));

export const getInfantAgeDatesOfBirth = (datesOfBirth: string[]): Date[] =>
  datesOfBirth.map((dob) => new Date(dob)).filter(isInfant);
